import { render, staticRenderFns } from "./SkuDonut.vue?vue&type=template&id=2ed5fb56&scoped=true&"
import script from "./SkuDonut.vue?vue&type=script&lang=js&"
export * from "./SkuDonut.vue?vue&type=script&lang=js&"
import style0 from "./SkuDonut.vue?vue&type=style&index=0&id=2ed5fb56&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5fb56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
